import { createContext, useContext } from 'react'
import type { BettingProviderInterface } from './bettingProviderTypes'

export const BettingContext = createContext<BettingProviderInterface>({
  addToBetslip: () => false,
  addToCart: () => false,
  removeFromBetslip: () => {},
  type: 'none',
  userData: null,
  // No provider means nothing to wait for: the mount attributes are the
  // whole identity.
  userDataResolved: true,
})

export function useBettingProvider() {
  return useContext(BettingContext)
}
